const DimensionIcon = ({ ...props }) => {
  return (
    <svg className="h-5 w-5" viewBox="0 0 100 100" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 4.16667C10 1.87 8.13 0 5.83333 0H4.16667C1.87 0 0 1.87 0 4.16667V95.8333C0 98.13 1.87 100 4.16667 100H5.83333C8.13 100 10 98.13 10 95.8333V23.3333V23.3233V4.16667Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M95.8333 0H94.1667C91.87 0 90 1.87 90 4.16667V23.3333V95.8333C90 98.13 91.87 100 94.1667 100H95.8333C98.13 100 100 98.13 100 95.8333V4.16667C100 1.87 98.13 0 95.8333 0Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M81.3708 14.014C81.0725 13.559 80.5842 13.2407 79.9992 13.2407C79.0792 13.2407 78.3325 13.9873 78.3325 14.9073V21.6673H21.6658V15.0007C21.6658 14.7823 21.6225 14.5673 21.5375 14.3623C21.3692 13.9557 21.0442 13.6307 20.6375 13.4623C20.2292 13.294 19.7708 13.294 19.3625 13.4623C19.1592 13.5457 18.9742 13.669 18.8208 13.8223L10.4875 22.1557C10.4092 22.234 10.3692 22.334 10.3108 22.424C10.2475 22.5173 10.1658 22.6007 10.1242 22.7023C10.0842 22.8023 10.0825 22.9123 10.0608 23.0173C10.0408 23.1207 10.0008 23.219 9.99917 23.324C9.99917 23.3257 10.0008 23.3273 10.0008 23.329C10.0008 23.3307 9.99917 23.3323 9.99917 23.334C9.99917 23.434 10.0392 23.529 10.0575 23.629C10.0775 23.739 10.0792 23.8507 10.1208 23.9557C10.1592 24.0523 10.2375 24.1307 10.2942 24.219C10.3558 24.3157 10.3975 24.4207 10.4825 24.5057L18.8158 32.9307C18.8158 32.9323 18.8175 32.9323 18.8175 32.9323C18.9725 33.089 19.1558 33.2123 19.3608 33.2973C19.5642 33.3823 19.7825 33.4257 19.9992 33.4257C20.2158 33.4257 20.4308 33.3823 20.6342 33.2973C20.7908 33.234 20.9208 33.1307 21.0492 33.0257C21.0875 32.994 21.1358 32.9807 21.1725 32.944C21.1725 32.944 21.1725 32.9423 21.1742 32.9407C21.3292 32.7873 21.4525 32.604 21.5375 32.4007C21.6225 32.1973 21.6658 31.9807 21.6658 31.764V31.759V25.0007H78.3325V31.6673C78.3325 31.884 78.3775 32.099 78.4625 32.304C78.6308 32.7107 78.9558 33.0357 79.3625 33.204C79.5675 33.289 79.7825 33.334 79.9992 33.334C80.2175 33.334 80.4325 33.289 80.6375 33.204C80.8408 33.1207 81.0258 32.999 81.1792 32.844L89.5125 24.5123C89.8375 24.1857 89.9992 23.759 89.9992 23.334C89.9992 22.9073 89.8375 22.4807 89.5125 22.1557L81.3708 14.014Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M50.1497 52.7083L44.468 64.0683L44.353 64.3683C43.5597 67.2216 44.0663 70.1233 45.7413 72.3266C46.948 73.9133 48.5947 74.8616 50.1497 74.8616C51.853 74.8616 53.6997 73.725 54.973 71.895C56.5363 69.6466 56.8747 66.8533 55.9013 64.235L50.1497 52.7083Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M66.3078 80.3938C68.9378 79.5338 71.0028 77.4355 71.9728 74.6355L73.8328 61.7488L62.7012 67.8655L62.5478 67.9605C60.2578 69.5622 58.9495 72.0522 58.9578 74.7922C58.9645 77.0188 59.8378 79.0055 61.2395 79.9738C62.0028 80.4988 62.9828 80.7688 64.0512 80.7688C64.7762 80.7688 65.5428 80.6438 66.3078 80.3938Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M37.8003 67.8475L26.272 61.7942L28.3253 74.3292L28.3637 74.5059C29.1103 77.1975 31.0203 79.2625 33.6053 80.1692C34.4803 80.4759 35.3653 80.6259 36.2003 80.6259C37.372 80.6259 38.4453 80.3292 39.2503 79.7459C40.5103 78.8359 41.292 77.1025 41.3403 75.1109C41.4053 72.3442 40.1153 69.6959 37.8003 67.8475Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M73.8217 82.4528C70.9933 81.5745 68.0767 81.9895 65.825 83.5962C64.2017 84.7512 63.2033 86.3695 63.1567 87.9245C63.1033 89.6262 64.1833 91.5095 65.9733 92.8362C67.4167 93.9078 69.11 94.4578 70.8533 94.4578C71.765 94.4578 72.6917 94.3062 73.6017 94.0012L85.2983 88.6045L74.1183 82.5778L73.8217 82.4528Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M34.4767 83.5987C32.2233 81.992 29.3083 81.572 26.48 82.452L15 88.597L26.5283 93.932L26.695 93.9987C27.6067 94.307 28.535 94.4587 29.4483 94.4587C31.1883 94.4587 32.88 93.9087 34.3233 92.8387C36.1133 91.512 37.1933 89.6303 37.1433 87.9287C37.095 86.3753 36.1 84.7553 34.4767 83.5987Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default DimensionIcon;
